export {};

const voyoContentTagsDiv = document.getElementById('voyoContentTags');
const searchInput = document.getElementById('searchInput') as HTMLInputElement;

// This immediatelly adds correct search value to input and focuses it.
const urlParams = new URLSearchParams(document.location.search);
const query = urlParams.get('q') || '';
searchInput.value = query;
searchInput.focus();

// One debounce for both the top menu input and the mobile input.
let debouncedSearch: Function = () => {};

document.addEventListener('started', (event) => {
    debouncedSearch = app.rateLimiter.debounce(doSearch, 300);
    mountTagsSplide();
});

function mountTagsSplide(): void {
    if (typeof Splide === 'undefined') {
        return;
    }

    const splideEl = app.html.q('.splide.tags-splide');

    // 5ka search has no tags
    if (!splideEl) {
        return;
    }

    const splide = new Splide(splideEl).mount();

    // Scroll to the selected tag. +15px so a bit of previous tag is still visible.
    const selected_tag = app.html.q('#voyoContentTags .tag_selected');

    if (selected_tag) {
        const selected_slide = selected_tag.closest('.splide__slide') as HTMLElement | null;
        if (selected_slide) {
            splide.Components.Scroll.scroll(-selected_slide.offsetLeft + 15, 0, false);
        }
    }
}

document.addEventListener('search', (event) => {
    debouncedSearch();
});

function onSelectTag(event: Event): void {
    if (!window.app) {
        return;
    }

    const target = event.target as HTMLElement;

    if (!voyoContentTagsDiv || !target) {
        return;
    }

    if (app.html.hasClass('body', 'search_results_timeshift')) {
        return;
    }

    // Deselect currently selected tag if user clicked on it again
    if (app.html.hasClass(target, 'tag_selected')) {
        app.html.removeClass(target, 'tag_selected');
        app.html.removeClass(voyoContentTagsDiv, 'has_selected');
    } else {
        // disable any currently selected tag
        app.html.removeClass('#voyoContentTags .tag_selected', 'tag_selected');
        // enable the selected tag
        app.html.toggleClass(target, 'tag_selected');
        app.html.addClass(voyoContentTagsDiv, 'has_selected');
    }

    doSearch();
}

function matchesCurrentSearch(query: string, tag: string): boolean {
    const curr = new URLSearchParams(document.location.search);
    const currQuery = curr.get('q') || '';
    const currTag = curr.get('tag') || '';

    return query === currQuery && tag === currTag;
}

function doSearch(): void {
    const query = searchInput.value.trim();
    const selectedTag = app.html.q('#voyoContentTags .tag_selected');
    const tag = selectedTag ? selectedTag.textContent || '' : '';

    if (matchesCurrentSearch(query, tag)) {
        return;
    }

    app.search.performSearch(query, tag)
        .catch(() => null);
}

function toggleResultsLibrary(): void {
    if (!window.app) {
        return;
    }

    app.html.removeClass('body', 'search_results_timeshift');
    app.html.removeClass('#searchTypesTimeshift', 'selected');
    app.html.addClass('#searchTypesLibrary', 'selected');

    app.html.removeClass('#searchResultsLibrary', 'hidden');
    app.html.addClass('#searchResultsTimeshift', 'hidden');
}

function toggleResultsTimeshift(): void {
    if (!window.app) {
        return;
    }

    app.html.addClass('body', 'search_results_timeshift');
    app.html.removeClass('#searchTypesLibrary', 'selected');
    app.html.addClass('#searchTypesTimeshift', 'selected');

    app.html.addClass('#searchResultsLibrary', 'hidden');
    app.html.removeClass('#searchResultsTimeshift', 'hidden');
}

function onMobileSearchInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const query = input.value.trim();

    searchInput.value = query;

    debouncedSearch();
}

window.onSelectTag = onSelectTag;
window.toggleResultsLibrary = toggleResultsLibrary;
window.toggleResultsTimeshift = toggleResultsTimeshift;
window.onMobileSearchInputChange = onMobileSearchInputChange
